import { render, staticRenderFns } from "./exportPdf.vue?vue&type=template&id=487a9a84&scoped=true&"
import script from "./exportPdf.vue?vue&type=script&lang=js&"
export * from "./exportPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a9a84",
  null
  
)

export default component.exports